import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ThemeMode, ThemeState } from '@/types/theme'

interface ThemeStoreState extends ThemeState {
  systemTheme: 'light' | 'dark'
  setSystemTheme: (theme: 'light' | 'dark') => void
}

export const useThemeStore = create<ThemeStoreState>()(
  persist(
    (set, get) => ({
      mode: 'system',
      systemTheme: 'light',
      effectiveMode: 'light',
      setMode: (mode: ThemeMode) => {
        const { systemTheme } = get()
        set({
          mode,
          effectiveMode: mode === 'system' ? systemTheme : mode,
        })
      },
      setSystemTheme: (theme: 'light' | 'dark') => {
        const { mode } = get()
        set({
          systemTheme: theme,
          effectiveMode: mode === 'system' ? theme : get().effectiveMode,
        })
      },
    }),
    {
      name: 'theme-storage',
      partialize: (state) => ({ mode: state.mode }),
    },
  ),
)
